import CryptoJS from 'crypto-js';
import { isWeb } from './platform';

const encryptionKey = 'your-secret-encryption-key';

export const SetLocalStorage = (key: string, data: any) => {
  // const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), encryptionKey).toString();
  const encryptedData = JSON.stringify(data);
  localStorage.setItem(key, encryptedData);
};

export const GetLocalStorage = (key: string) => {
  const encryptedData = localStorage.getItem(key);
  if (isWeb && encryptedData) {
    // const decryptedData = CryptoJS.AES.decrypt(encryptedData, encryptionKey).toString(CryptoJS.enc.Utf8);
    return JSON.parse(encryptedData);
  }
};

export const SetSessionStorage = (key: string, data: any) => {
  // const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), encryptionKey).toString();
  const encryptedData = JSON.stringify(data);
  sessionStorage.setItem(key, encryptedData);
}